const createSpinner = () => {
  const spinner = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
  spinner.setAttribute('class', 'spinner-svg')
  spinner.setAttribute('viewBox', '0 0 50 50')
  spinner.setAttribute('width', '40')
  spinner.setAttribute('height', '40')

  // Style for the spinner
  spinner.style.position = 'absolute'
  spinner.style.top = '50%'
  spinner.style.left = '50%'
  spinner.style.transform = 'translate(-50%, -50%)'
  spinner.style.zIndex = '10'

  // Create the circular path
  const circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle')
  circle.setAttribute('cx', '25')
  circle.setAttribute('cy', '25')
  circle.setAttribute('r', '20')
  circle.setAttribute('fill', 'none')
  circle.setAttribute('stroke', '#3498db')
  circle.setAttribute('stroke-width', '5')
  circle.setAttribute('stroke-linecap', 'round')

  // Create the animation
  circle.innerHTML = `
    <animate
      attributeName="stroke-dasharray"
      values="1, 150; 90, 150; 90, 150"
      dur="1.5s"
      repeatCount="indefinite"
    />
    <animate
      attributeName="stroke-dashoffset"
      values="0; -35; -124"
      dur="1.5s"
      repeatCount="indefinite"
    />
  `

  spinner.appendChild(circle)
  return spinner
}

export { createSpinner }
